import { Injectable } from '@angular/core';
import { LoginService } from '../../pages/login';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { GlobalState } from '../../global.state';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CacheService } from './permission';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  private isRefreshing$ = new BehaviorSubject<boolean>(false);
  constructor(private router: Router, private http: HttpClient,private gblstate:GlobalState, private cache:CacheService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let token = this.cache.get('TOKEN');
    if (token && token!== "undefined") {
        request = this.addAuthHeader(request, token);
    }

    return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                console.log(error)
                if (error && error.error && error.error.message)
                    alert(error.error.message);
                else if (error && error.error && error.error.result)
                    alert(error.error.result);
                if (error.url && error.url.endsWith('/refreshToken')) {
                    this.router.navigate(['/login']);
                    return of(new HttpResponse({ body: {}, status: 0 }));
                }
                if (error.status === 401 || error.status === 403 || error.status === 419) {
                    if(!error.url.endsWith('/jwt'))
                        return this.handle401(request, next)
                }
                return throwError(() => error);
            })
        ) as any;
  }

  private handle401(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<any> {
        /**
         * If we're not refreshing a token, refresh it
         * and retry the original request.
         */
        if (!this.isRefreshing$.getValue()) {
          this.isRefreshing$.next(true);

          let arr =this.gblstate.getGlobalSetting("apiUrl");
          let option = { withCredentials: true };
          return this.http.post( arr[0] +'/refreshToken', { },option)
          .pipe(
            tap(( token:any ) => {
              this.cache.set('TOKEN', token.token);
                  this.isRefreshing$.next(false);
              }),
              switchMap(({ token }) => {
                  console.log({ "switchMap": token });
                  return next.handle(this.addAuthHeader(request, token));
              }),
              catchError((err) => {
                  this.isRefreshing$.next(false);
                  //this.authService.onError();
                  return Observable.throw(err);
              })
          );
        }

        /**
         * If we're already refreshing a token, wait
         * until we get the new one and perform the
         * request with the new Access Token.
         */
        return this.isRefreshing$.pipe(
            filter((is) => !is),
            take(1),
            switchMap(() => {
                return next.handle(this.addAuthHeader(request));
            })
        );
    }

     addAuthHeader(request: HttpRequest<any>, token?: string): HttpRequest<any> {
        if (!token)
            token = this.cache.get('TOKEN') || "";
        return request.clone({
            setHeaders: {
                Authorization: token
            }
        });
    }

   
}


